<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
      <fullscreen
        background="#F3F5F7"
        class="table-fullscreen"
        ref="fullscreen"
        @change="fullScreenChange"
      >
        <div class="page-table-header">
          <div class="title-container">
            <h3 class="title log_time_head">
              Bulk Payouts (old)
              <div
                v-if="isLoading"
                class="spinner-border spinner-theme_default"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </h3>
            <div class="title-container__controls">
              <div class="payrolls-datepicker">
                <b-button
                  variant="outline"
                  class="button"
                  :disabled="isLoading"
                  @click.prevent="changeMonth('prev')"
                >
                  ‹
                </b-button>
                <Datepicker
                  :bootstrap-styling="true"
                  :value="dateYM"
                  :disabledDates="disabledDates"
                  format="yyyy-MM"
                  minimum-view="month"
                  :disabled="isLoading"
                  @selected="selectMonth"
                  class="datapicker"
                />
                <b-button
                  variant="outline"
                  class="button"
                  :disabled="isLoading"
                  @click.prevent="changeMonth('next')"
                >
                  ›
                </b-button>
                <!--<b-button
                  variant="success"
                  v-if="$can(permissions.CreateFinancesInvoices)"
                  type="button"
                  class="button ml-2"
                  @click.prevent="showCreateModal"
                  :disabled="isLoading"
                >
                  Create
                </b-button>-->
              </div>
            </div>
          </div>

          <div class="d-flex mb-3">
            <div class="d-flex justify-content-start">
              <div class="row align-items-center justify-content-start"
                   v-if="currencyRates[dateYM] && currencyRates[dateYM]['USD']">
                <div class="row align-items-center ml-3">
                  <div class="col-4 p-0">
                    <label
                      class="exchange-label"
                      style="margin-bottom: unset; white-space: nowrap;"
                      for="currency_rate_usd"
                    >USD ex rate</label>
                  </div>
                  <div class="col-4 p-0">
                    <b-form-input
                      id="currency_rate_usd"
                      type="number"
                      style="background: #fff"
                      size="md"
                      @input="exchangeRateEdited()"
                      @keydown="preventDotsInExchangeRate($event)"
                      v-model.number="currencyRates[dateYM]['USD']"
                    />
                  </div>
                  <div class="col-4 p-0">
                    <b-button
                      class="
                      button
                      ml-auto
                      mr-md-2
                      ml-md-2
                      float-left
                    "
                      variant="primary"
                      type="button"
                      @click="saveCurrencyRate('USD')"
                      :disabled="!isExchangeRateEdited"
                    >
                      Save
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex" style="width:100%">
              <div class="justify-content-end d-flex payrolls-control-buttons" style="width:100%">
                <div>
                  <b-button
                    class="
                      button
                      ml-auto
                      mr-md-5
                      ml-md-2
                      float-left
                    "
                    variant="outline-dark"
                    type="button"
                    :disabled="loading"
                    @click="exportPayrolls"
                  >
                    <font-awesome-icon icon="copy" style="margin:2px 7px 0px 0px"/>Export XLS
                  </b-button>
                </div>
                <div>
                  <b-button
                    class="
                      button
                      ml-auto
                      mr-md-2
                      ml-md-2
                      float-left
                    "
                    variant="success"
                    type="button"
                    @click="recalcAll"
                    :disabled="!canBeRecalcAll || !canEdit"
                  >
                    Recalculate All
                  </b-button>
                  <b-button
                    class="
                      button
                      ml-auto
                      mr-md-2
                      ml-md-2
                      float-left
                    "
                    variant="primary"
                    v-if="payrolls"
                    type="button"
                    @click="saveAll"
                    :disabled="!isAnyUserEdited || !canEdit"
                  >
                    Save All
                  </b-button>
                  <b-button
                    class="
                      button
                      ml-auto
                      mr-md-2
                      ml-md-2
                      float-left
                    "
                    variant="outline"
                    type="button"
                    @click="resetAll"
                    :disabled="!canEdit || isLoading"
                  >
                    Reset All
                  </b-button>
                  <b-button
                    class="button
                    ml-auto
                    mr-md-2
                    ml-md-2
                    float-left btn-outline"
                    :variant="isShowFilter ? 'secondary' : 'info'"
                    @click="toggleShowFilter"
                  >
                    <span class="material-icons icon-image-preview">
                      tune
                    </span>
                    Filters
                  </b-button>
                  <b-button
                    class="button btn-icon mr-1"
                    variant="outline-info"
                    @click="toggleFullscreen"
                  >
                    <span class="material-icons">
                      fullscreen_exit
                    </span>
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <Filters
            v-show="isShowFilter"
            textButtonSubmit="Filter"
            :data="getTableFilters"
            :isLoading="isLoading"
            :data-changes="true"
            @changes="checkChanges"
            @submit="setFilterData"
          />

          <TableForPage
            :tableData="getUsersData"
            :fields="table.fields"
            :slots="table.slots"
            :sticky-header="false"
            :per-page="10"
          >
            <template v-slot:user="data">
              <TableUserItem :user="data.item.user" :number="data.item.number"/>
            </template>
            <template v-slot:formula="data">
              <div class="d-flex align-items-stretch">
                <div class="flex-grow-1 position-relative">
                  <b-form-input
                    type="text"
                    v-model="data.item.payrolls[dateYM].formula"
                    value="data.item.payrolls[dateYM].formula"
                    @input="markAsFormulaEdited(data.item, data.index)"
                    :placeholder="data.item.payrolls[dateYM].has_compensations ? 'Formula' : 'User doesn\'t have compensation for this month'"
                    required
                    :readonly="!canEdit || !data.item.payrolls[dateYM].has_compensations"
                  ></b-form-input>
                  <b-form-input
                    :ref="'calculationByFormula' + data.item.user.id"
                    class="mt-2"
                    type="text"
                    v-model="data.item.payrolls[dateYM].calculation_by_formula"
                    value="data.item.payrolls[dateYM].calculation_by_formula"
                    @input="markAsEdited(data.item, data.index)"
                    placeholder="Calculated by formula"
                    required
                    :readonly="!canEdit"
                    disabled
                  ></b-form-input>
                  <div
                    class="mx-2 mt-3 position-absolute"
                    style="right:3px; bottom:8px;"
                    v-if="data.item.payrolls[dateYM].amount_formula"
                    v-b-tooltip.hover="{ variant: 'base', delay: { show: 50, hide: 500 }, container: 'tooltip-container'}"
                    :title="'$amount = ' + data.item.payrolls[dateYM].amount_formula">
                    <font-awesome-icon icon="info"/>
                  </div>
                </div>
                <div>
                  <b-button
                    class="button mx-2"
                    variant="success"
                    type="button"
                    @click="recalc(data.item)"
                    :disabled="
                      isDisabledForActions(data.item)
                      || data.item.payrolls[dateYM].editedFormula === undefined
                      || !data.item.payrolls[dateYM].has_compensations
                    ">
                    Recalc
                  </b-button>
                  <div class="mt-2 ml-2">
                    <b-button
                      class="btn btn-light"
                      style="padding: 2px 10px;"
                      :disabled="data.item.payrolls[dateYM].calculation_by_formula.length === 0"
                      @click="copyToClipboard(data.item.user.id)">
                      <font-awesome-icon icon="copy"/>
                    </b-button>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:payrolls="data">
              <b-form-input
                type="number"
                v-model="data.item.payrolls[dateYM].amount"
                value="data.item.payrolls[dateYM].amount"
                @input="markAsEdited(data.item, data.index)"
                placeholder="Amount"
                required
                :readonly="!canEdit"
                @keyup.enter="save(data.item)"
              ></b-form-input>
              <multiselect
                v-model="data.item.payrolls[dateYM].currency"
                @select="markAsFormulaEdited(data.item, data.index)"
                :options="currencies"
                placeholder="Currency"
                required
                :disabled="!canEdit"
                track-by="id"
                label="code"
                :allow-empty="false"
                :showLabels="false"
                class="mt-1"
              />
            </template>
            <template v-slot:controls="data">
              <b-button
                class="button"
                variant="primary"
                type="submit"
                @click="save(data.item)"
                :disabled="
                  isDisabledForActions(data.item)
                  || data.item.payrolls[dateYM].edited === undefined
                "
              >
                Save
              </b-button>
              <b-button
                class="button btn-outline mt-2"
                variant="outline"
                type="submit"
                @click="reset(data.item)"
                :disabled="
                  isDisabledForActions(data.item)
                  || !data.item.payrolls[dateYM].has_compensations
                "
              >
                Reset
              </b-button>
            </template>
          </TableForPage>

          <div v-if="totalAmountAtDateYm">
            <div class="mt-3">
              <b-card-group deck class="mb-3">
                <b-card border-variant="dark" class="text-center">
                  <b-card-text>
                    <h3>Original totals</h3>
                    <span v-for="(amount, currencyCode) in totalAmountAtDateYm.original" :key="currencyCode">
                          {{ amount }}
                          <b-badge variant="light"> {{currencyCode}} </b-badge>
                      </span>
                  </b-card-text>
                </b-card>

                <b-card border-variant="dark" align="center">
                  <b-card-text>
                    <h3>Equivalent totals</h3>
                    <span v-for="(amount, currencyCode) in totalAmountAtDateYm.equivalent" :key="currencyCode">
                          {{ amount }}
                          <b-badge variant="light"> {{currencyCode}} </b-badge>
                      </span>
                  </b-card-text>
                </b-card>

              </b-card-group>
            </div>
          </div>

          <error-modal ref="errorModal" />
        </div>
        <vue-snotify></vue-snotify>
        <div id="tooltip-container"></div>
        <ConfirmModal ref="confirm" />
        <FinancePayoutsModal
          v-model="createModal.show"
          mode="create"
          :data="createModal.form"
          :title="createModal.title"
          :submitButtonText="createModal.submitButtonText"
          @submit="createFinancePayouts"
        />
      </fullscreen>
      </div>
    </div>
  </div>
</template>
<script>
import { permissions } from '@mocks/permissions'
import { mapGetters } from 'vuex'
import Moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import FinanceMixin from '../mixins/FinanceMixin'
import FrontFilterMixin from '../mixins/FrontFilterMixin'
import ErrorModal from '../components/modals/ErrorModal.vue'
import ConfirmModal from '@components/modals/ConfirmModal'
import Filters from '@components/Filter/Filter'
import TableForPage from '@tables/TableForPage'
import TableUserItem from '@components/tables/TableUserItem'
import FinancePayoutsModal from '@components/modals/FinancePayoutsModal/FinancePayoutsModal'

export default {
  name: 'FinancesPayrolls',
  components: {
    ErrorModal,
    ConfirmModal,
    TableForPage,
    Datepicker,
    TableUserItem,
    FinancePayoutsModal,
    Filters
  },
  mixins: [FinanceMixin, FrontFilterMixin],
  data () {
    return {
      permissions,
      loading: true,
      fullscreen: false,
      payrolls: [],
      totalAmount: null,
      currencyRates: [],
      dateYM: '',
      isAnyUserEdited: false,
      requestedUsers: [],
      canBeRecalcAll: false,
      isExchangeRateEdited: false,
      filteredUsers: [],
      table: {
        fields: [
          {
            key: 'user',
            label: 'Name',
            thStyle: { width: '200px' }
          },
          {
            key: 'formula',
            label: 'Formula'
          },
          {
            key: 'payrolls',
            label: 'Amount',
            thStyle: { width: '120px' }
          },
          {
            key: 'controls',
            label: 'Controls',
            thStyle: { width: '90px' }
          }
        ],
        slots: {
          user: {
            name: 'user'
          },
          payrolls: {
            name: 'payrolls'
          },
          controls: {
            name: 'controls'
          },
          formula: {
            name: 'formula'
          }
        }
      },
      createModal: {
        show: false,
        title: `Create payouts`
      },
      filter: {
        fields: {
          'users': {
            type: 'multiselect',
            name: 'users',
            label: 'Select user',
            class: 'col-md-3',
            valueField: 'jira_user_name',
            selectLabel: 'name',
            options: [],
            value: []
          },
          'user_status': {
            type: 'select',
            name: 'user_status',
            label: 'Select status',
            class: 'col-md-2',
            valueField: 'status',
            selectLabel: 'label',
            options: [{ status: 'all', label: 'All' }, { status: 'active', label: 'Active' }, { status: 'inactive', label: 'Inactive' }],
            value: null
          },
          'users_roles': {
            type: 'multiselect',
            name: 'users_roles',
            label: 'Select role',
            class: 'col-md-2',
            valueField: 'name',
            selectLabel: 'display_name',
            options: [],
            value: []
          },
          'employment_type': {
            type: 'select',
            name: 'employment_type',
            label: 'Select employment type',
            class: 'col-md-2',
            valueField: 'type',
            selectLabel: 'label',
            options: [
              { type: 'all', label: 'All empl. types' },
              { type: 'team_member', label: 'Team member' },
              { type: 'independent', label: 'Independent' },
              { type: 'partner', label: 'Partner' }
            ],
            value: { type: 'all', label: 'All empl. types' }
          },
          'partners': {
            type: 'multiselect',
            name: 'partners',
            label: 'Select partner',
            class: 'col-md-3',
            valueField: 'id',
            selectLabel: 'company_name',
            options: [],
            value: [],
            hidden: true
          }
        }
      }
    }
  },
  created () {
    (async () => {
      this.setDateYM(Moment().subtract(1, 'months').toDate())
      this.loading = true

      Promise.all([
        this.$api.users.getAllUsers(),
        this.$api.roles.getRoles(),
        this.$api.finances.getCurrencies(),
        this.$api.partners.getAllPartners(),
        this.getCurrencyRates(),
        this.getPayrolls()
      ]).then(() => {
        this.checkAnyCanBeRecalc()
        this.checkAnyCanBeSaved()
        this.setAllOptionsFilter()
        this.loading = false
      })
    })()
  },
  computed: {
    ...mapGetters({
      getUserRoles: 'getRoles',
      getAllPartners: 'partners/getAllPartners'
    }),
    isLoading () {
      return this.loading || this.requestedUsers.length > 0
    },
    getTableFilters () {
      return this.filter.fields || {}
    },
    allUsers () {
      return this.$store.getters.getAllUsers || []
    },
    currencies () {
      return this.$store.getters.getCurrencies.filter(currency => ['USD', 'UAH'].includes(currency.code)) || []
    },
    canEdit () {
      return this.$can('update_all-finances_payrolls')
    },
    disabledDates () {
      const dateDisabledFrom = Moment(this.dateYMTo, 'YYYY-MM').add(1, 'months').subtract(1, 'day').toDate()
      const dateDisabledTo = Moment(this.dateYMFrom, 'YYYY-MM').toDate()
      return { from: dateDisabledFrom, to: dateDisabledTo }
    },
    dateYMFrom () {
      return Moment().subtract(12, 'months').format('YYYY-MM')
    },
    dateYMTo () {
      return Moment().format('YYYY-MM')
    },
    payrollsAtDateYm () {
      const currentPayrolls = this.payrolls.filter(item => item.payrolls[this.dateYM] !== undefined)
      return currentPayrolls.map((item, index) => { return { ...item, number: index } })
    },
    totalAmountAtDateYm () {
      return this.totalAmount ? this.totalAmount[this.dateYM] : 0
    },
    getUsersData () {
      if (!this.filteredUsers.length && !this.filterState) {
        return this.payrollsAtDateYm
      }
      return this.filteredUsers.map((item, index) => {
        item.number = index
        return { ...item }
      }) || []
    }
  },
  methods: {
    isDisabledForActions (item) {
      return !this.canEdit || this.requestedUsers.indexOf(item.user.id) !== -1
    },
    showCreateModal () {
      this.createModal.show = true
      this.createModal.form = null
    },
    setAllOptionsFilter () {
      this.filter.fields.users.options = this.allUsers
      this.filter.fields.users_roles.options = [
        {
          display_name: 'All',
          name: 'all'
        },
        ...this.getUserRoles
      ]
      this.filter.fields.partners.options = [
        {
          company_name: 'All partners',
          name: 'All'
        },
        ...this.getAllPartners // for example
      ]
    },
    markAsEdited (item) {
      this.isAnyUserEdited = true
      item.payrolls[this.dateYM].edited = true
    },
    markAsFormulaEdited (item) {
      this.isAnyUserEdited = true

      item.payrolls[this.dateYM].edited = true
      if (item.payrolls[this.dateYM].formula.length > 0) {
        item.payrolls[this.dateYM].editedFormula = true
        this.canBeRecalcAll = true
      }
    },
    getPayrolls () {
      this.loading = true
      return this.axios
        .get('/api/finances/payrolls', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          },
          params: {
            date_ym_from: this.dateYMFrom,
            date_ym_to: this.dateYMTo
          }
        })
        .then((response) => {
          this.payrolls = Object.values(response.data.payrolls)
          this.totalAmount = response.data.totalAmount
        })
        .catch((error) => {
          this.errorNotifications(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async changeMonth (type) {
      if (this.isExchangeRateEdited) {
        await this.exchangeRateIsNotSaved()
      }

      const currentMonth = Moment(this.dateYM, 'YYYY-MM')
      let newMonth

      if (type === 'next') {
        newMonth = currentMonth.add(1, 'months').format('YYYY-MM')
        if (newMonth > this.dateYMTo) {
          return
        }
      } else {
        newMonth = currentMonth.subtract(1, 'months').format('YYYY-MM')
        if (newMonth < this.dateYMFrom) {
          return
        }
      }

      this.dateYM = newMonth

      this.checkAnyCanBeRecalc()
      this.checkAnyCanBeSaved()
    },
    setDateYM (date) {
      const dateYM =
        '' + date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2)
      this.dateYM = dateYM
    },
    async exchangeRateIsNotSaved () {
      const confirm = await this.$refs.confirm.open(
        'Currency rate was changed',
        'Currency rate for month ' + this.dateYM + ' was changed. Do you want to save it before change month?',
        { submitText: 'Save new currency rate' }
      )
      if (confirm) {
        this.saveCurrencyRate('USD')
      }
      this.isExchangeRateEdited = false
    },
    async selectMonth (data) {
      if (this.isExchangeRateEdited) {
        await this.exchangeRateIsNotSaved()
      }
      this.setDateYM(new Date(data))
    },
    getCurrencyRates () {
      this.axios
        .get('/api/finances/currencies/rates-for-payrolls', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          },
          params: {
            date_ym_from: this.dateYMFrom,
            date_ym_to: this.dateYMTo
          }
        })
        .then((response) => {
          this.currencyRates = response.data
        })
        .catch((error) => {
          this.errorNotifications(error)
        })
    },
    saveCurrencyRate (currencyCode) {
      this.loading = true
      this.axios
        .post('/api/finances/currencies/rates-for-payrolls', {
          date_ym: this.dateYM,
          currency_code: currencyCode,
          rate: this.currencyRates[this.dateYM][currencyCode]
        }, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(({ data }) => {
          this.isExchangeRateEdited = false
          this.$snotify.success(
            'Currency rate for payrolls successfully saved',
            'Success',
            this.$store.state.snotify
          )
        })
        .catch((error) => {
          this.errorNotifications(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    preventDotsInExchangeRate (e) {
      if (e.key === '.') {
        e.preventDefault()
      }
    },
    exchangeRateEdited () {
      this.isExchangeRateEdited = true
      for (const i in this.payrollsAtDateYm) {
        if (this.payrollsAtDateYm[i].payrolls[this.dateYM].formula.length > 0) {
          this.payrollsAtDateYm[i].payrolls[this.dateYM].editedFormula = true
        }
      }
      this.payrolls.push({})
      this.payrolls.pop()
      this.checkAnyCanBeRecalc()
    },
    save (data, event) {
      this.saveRequest([data])
        .then(() => {
          this.$snotify.success(
            data.user.name + ' was successfully saved',
            'Success',
            this.$store.state.snotify
          )
        })
        .catch((error) => {
          this.errorNotifications(error)
          this.isAnyUserEdited = true
        })
    },
    saveAll () {
      const savedUsers = []
      for (const i in this.payrollsAtDateYm) {
        const userPayrolls = this.payrollsAtDateYm[i].payrolls[this.dateYM]
        if (userPayrolls && userPayrolls.edited) {
          savedUsers.push(this.payrollsAtDateYm[i])
        }
      }
      this.isAnyUserEdited = false

      this.saveRequest(savedUsers)
        .then(() => {
          this.$snotify.success(
            'Users for month ' + this.dateYM + ' were successfully saved',
            'Success',
            this.$store.state.snotify
          )
        })
        .catch((error) => {
          this.errorNotifications(error)
          this.isAnyUserEdited = true
        })
    },
    saveRequest (savedUsers) {
      const payrolls = []
      for (const i in savedUsers) {
        const savedUser = savedUsers[i]
        payrolls.push({
          user_id: savedUser.user.id,
          amount: savedUser.payrolls[this.dateYM].amount,
          currency_id: savedUser.payrolls[this.dateYM].currency.id,
          formula: savedUser.payrolls[this.dateYM].formula,
          calculation_by_formula: savedUser.payrolls[this.dateYM].calculation_by_formula,
          amount_formula: savedUser.payrolls[this.dateYM].amount_formula
        })
        this.requestedUsers.push(savedUser.user.id)
      }

      return this.axios
        .post('/api/finances/payrolls', {
          date_ym: this.dateYM,
          payrolls
        }, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(({ data }) => {
          for (const i in savedUsers) {
            const userId = savedUsers[i].user.id
            savedUsers[i].payrolls[this.dateYM].amount = data[userId].amount
            savedUsers[i].payrolls[this.dateYM].currency_id = data[userId].currency_id
            savedUsers[i].payrolls[this.dateYM].formula = data[userId].formula
            savedUsers[i].payrolls[this.dateYM].calculation_by_formula = data[userId].calculation_by_formula
            savedUsers[i].payrolls[this.dateYM].edited = undefined
          }
          this.checkAnyCanBeSaved()
        })
        .finally(() => {
          for (const i in savedUsers) {
            const index = this.requestedUsers.indexOf(savedUsers[i].user.id)
            if (index > -1) {
              this.requestedUsers.splice(index, 1)
            }
          }
        })
    },
    recalc (data) {
      this.recalcRequest([data])
        .then(() => {
          this.$snotify.success(
            data.user.name + ' was successfully recalculated',
            'Success',
            this.$store.state.snotify
          )
        })
        .catch((error) => {
          this.errorNotifications(error)
          this.canBeRecalcAll = true
        })
    },
    recalcAll () {
      const recalcUsers = this.payrollsAtDateYm.filter(
        (item) => item.payrolls[this.dateYM].editedFormula === true
      )
      this.canBeRecalcAll = false
      this.recalcRequest(recalcUsers)
        .then(() => {
          this.$snotify.success(
            'Users for month ' + this.dateYM + ' were successfully recalculated',
            'Success',
            this.$store.state.snotify
          )
        })
        .catch((error) => {
          this.errorNotifications(error)
          this.canBeRecalcAll = true
        })
    },
    async reset (data) {
      const confirm = await this.$refs.confirm.open(
        'Reset',
        'Are you sure you want to reset ' + data.user.name + ' formula to default value?',
        { submitText: 'Reset' }
      )
      if (!confirm) {
        return
      }
      this.recalcRequest([data], true)
        .then(() => {
          this.$snotify.success(
            data.user.name + ' was successfully reset',
            'Success',
            this.$store.state.snotify
          )
        })
        .catch((error) => {
          this.errorNotifications(error)
          this.canBeRecalcAll = true
        })
    },
    async resetAll () {
      const confirm = await this.$refs.confirm.open(
        'Reset All',
        'Are you sure you want to reset formula to default value for all users at ' + this.dateYM + ' month ?',
        { submitText: 'Reset all' }
      )
      if (!confirm) {
        return
      }
      this.recalcRequest(this.payrollsAtDateYm, true)
        .then(() => {
          this.$snotify.success(
            'Users for month ' + this.dateYM + ' were successfully reset',
            'Success',
            this.$store.state.snotify
          )
        })
        .catch((error) => {
          this.errorNotifications(error)
          this.canBeRecalcAll = true
        })
    },
    recalcRequest (recalcUsers, reset = false) {
      const payrolls = []
      const currencyRates = this.currencyRates[this.dateYM]

      for (const i in recalcUsers) {
        const recalcUser = recalcUsers[i]
        payrolls.push({
          user_id: recalcUser.user.id,
          currency_id: recalcUser.payrolls[this.dateYM].currency.id,
          formula: reset ? '' : recalcUser.payrolls[this.dateYM].formula
        })
        this.requestedUsers.push(recalcUser.user.id)
      }
      return this.axios
        .post('/api/finances/payrolls/recalculate', {
          date_ym: this.dateYM,
          currencyRates,
          payrolls
        }, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(({ data }) => {
          for (const i in recalcUsers) {
            const userId = recalcUsers[i].user.id
            if (data[userId] !== undefined) {
              recalcUsers[i].payrolls[this.dateYM].formula = data[userId].formula
              recalcUsers[i].payrolls[this.dateYM].calculation_by_formula = data[userId].calculation_by_formula
              recalcUsers[i].payrolls[this.dateYM].amount_formula = data[userId].amount_formula
              recalcUsers[i].payrolls[this.dateYM].amount = data[userId].amount
              if (recalcUsers[i].payrolls[this.dateYM].formula) {
                recalcUsers[i].payrolls[this.dateYM].edited = true
              }
            }
            recalcUsers[i].payrolls[this.dateYM].editedFormula = undefined
          }

          this.checkAnyCanBeRecalc()
          this.checkAnyCanBeSaved()
        })
        .finally(() => {
          for (const i in recalcUsers) {
            const index = this.requestedUsers.indexOf(recalcUsers[i].user.id)
            if (index > -1) {
              this.requestedUsers.splice(index, 1)
            }
          }
        })
    },
    checkAnyCanBeRecalc () {
      if (
        this.payrollsAtDateYm.filter(
          (item) => item.payrolls[this.dateYM].editedFormula === true
        ).length
      ) {
        this.canBeRecalcAll = true
      } else {
        this.canBeRecalcAll = false
      }
    },
    checkAnyCanBeSaved () {
      if (
        this.payrollsAtDateYm.filter(
          (item) => item.payrolls[this.dateYM].edited === true
        ).length
      ) {
        this.isAnyUserEdited = true
      } else {
        this.isAnyUserEdited = false
      }
    },
    copyToClipboard (userId) {
      this.$refs['calculationByFormula' + userId].$el.disabled = false
      this.$refs['calculationByFormula' + userId].$el.select()
      document.execCommand('copy')
      this.$refs['calculationByFormula' + userId].$el.disabled = true
    },
    exportPayrolls () {
      this.axios.post('/api/finances/payrolls/export',
        {
          date_ym: this.dateYM,
          users: this.payrollsAtDateYm.map(userItem => userItem.user.jira_user_name)
        }, {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute('download', 'payrolls-' + this.dateYM + '.xlsx')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
    },
    toggleFullscreen () {
      this.$refs['fullscreen'].toggle()
    },
    fullScreenChange (fullscreen) {
      this.fullscreen = fullscreen
    },
    createFinancePayouts (fields) {
      console.log(fields, 'CREATE')
    },
    setFilterData (data) {
      const filterByUser = data.users.value
      const filterByUserStatus = data.user_status.value
      const filterByUserRole = data.users_roles.value
      const filterByEmplType = data.employment_type.value
      const filterByPartners = data.partners.value

      let users = []

      this.checkFilters(data)

      if (filterByUser.length) {
        users = this.usersFilter(this.payrollsAtDateYm, filterByUser)
      } else {
        users = [...this.payrollsAtDateYm]
      }
      if (filterByUserStatus) {
        users = this.statusFilter(users, filterByUserStatus)
      }
      if (filterByUserRole.length) {
        users = this.rolesFilter(users, filterByUserRole)
      }

      if (filterByEmplType) {
        users = this.emplTypeFilter(users, filterByEmplType)
      }

      if (filterByPartners.length) {
        users = this.partnersFilter(users, filterByPartners)
      }

      this.filteredUsers = users
    }
  }
}
</script>

<style lang="scss">
.payrolls-datepicker {
  display: flex;
  .btn {
    line-height: 23px;
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .vdp-datepicker {
    margin: 0 5px;
  }
}

.exchange-label {
  line-height: 18px;
  font-size: 11px;
  color: #7489a9;
  font-weight: normal;
  text-transform: uppercase;
}

.payrolls-control-buttons button {
  white-space: nowrap;
}
</style>
